import React from "react";
import ProductOne from "../../image/ProductOne.png";
import email from "../../image/email.png";
import phone from "../../image/phone.png";
import map from "../../image/map.png";

const data = [
  {
    id: 1,
    icon: map,
    title: "Address",
    list: [
      "Maitha Alzaabi Auditing, office 1101, Ascot park palace Tower, World Trade center first, Dubai, UAE",
      "Park Place Tower - 1 شارع الشيخ زايد - المركز التجاري الأولي - دبي",
    ],
    url: "https://goo.gl/maps/QQn8pFCPaXcjmUzJ7",
  },
  {
    id: 2,
    icon: phone,
    title: "Phone",
    list: ["04 310 8555", " Whatsapp(+971 55 557 8859)"],
    url: "https://wa.me/971555578859",
  },
  {
    id: 3,
    icon: email,
    title: "Email",
    list: [
      "samy@colours-world.com",
      "ahmed@colours-world.com",
    ],
    url: "samy@colours-world.com",
  },
];

export default data;
